import React, { useCallback, useEffect } from 'react'
import { Route, useHistory, useParams } from 'react-router-dom'
import Avatar from '../../../components/Avatar/Avatar'
import Button from '../../../components/Button/Button'
import File from '../../../components/File/File'
import LoadingPanel from '../../../components/Loading/LoadingPanel'
import Panel from '../../../components/Panel/Panel'
import PanelTitle from '../../../components/Panel/PanelTitle'
import TextLink from '../../../components/TextLink/TextLink'
import convertDate from '../../../helpers/DateHelper'
import { oldGet } from '../../../helpers/requestOld'
import useForceUpdate from '../../../hooks/useForceUpdate'
import { ERROR, LOADING, RELOADING, READY, useVisualState } from '../../../hooks/useVisualState'
import OldPlayerFormModal from '../OldCm/OldPlayerFormModal'
import './PlayerView.scss'

const PlayerView = () => {
  const { competitionId, teamId, playerId } = useParams()
  const [[playerState, player], setPlayer] = useVisualState()
  const [update, forceUpdate] = useForceUpdate()
  const history = useHistory()

  const handleEdit = useCallback(() => {
    history.push(`/soccer/competition/${competitionId}/team/${teamId}/player/${playerId}/edit`)
  }, [competitionId, teamId, playerId, history])

  const handleClose = useCallback(() => {
    history.push(`/soccer/competition/${competitionId}/team/${teamId}/player/${playerId}`)
    forceUpdate()
  }, [competitionId, teamId, playerId, history, forceUpdate])

  useEffect(() => {
    setPlayer(RELOADING)
    oldGet('/delegate/teams/' + teamId + '/players/' + playerId)
      .then((response) => {
        setPlayer(READY, response)
      })
      .catch((error) => {
        setPlayer(ERROR, error)
      })
  }, [competitionId, teamId, playerId, setPlayer, update])

  return (
    <div className="main-content player-view-page">
      <div className="-page-header">
        <TextLink
            label="← Regresar a la lista de equipos"
            labelOrientation="right"
            size="small"
            icon="ArrowLeftIcon"
            link={"/soccer/competition/" + competitionId + "/team/" + teamId}
          />

        {(playerState === READY || playerState === LOADING) && player &&
          <div className='-title'>
            <Avatar source={player.avatar} size='large' alternative={player.first_name} />
            <div className='-data'>
              <div className="-left label-extra-large-semibold">{player.first_name} {player.last_name}</div>
              <div className="-left label-default-semibold">{convertDate(player.birth_date)} <small>({player.age} años)</small></div>
            </div>
            <div className="-buttons">
                <Button
                  type='dark'
                  size='field-sized'
                  color='green'
                  onClick={handleEdit}>
                  Editar
                </Button>
            </div>
          </div>
        }
      </div>
      <div className="-content">
        {(playerState === READY || playerState === LOADING) && player &&
          <>
            <Panel>
              <PanelTitle>Información adicional</PanelTitle>
              <div className="-properties">
                <div>
                  <div className='label-default-basic'>Género</div>
                  <div className='label-medium-semibold'>{renderGender(player.gender)}</div>
                </div>
                <div>
                  <div className='label-default-basic'>Nacionalidad</div>
                  <div className='label-medium-semibold'>{player.nationality || '-'}</div>
                </div>
                <div>
                  <div className='label-default-basic'>Número de camiseta</div>
                  <div className='label-medium-semibold'>{player.shirt_number || '-'}</div>
                </div>
              </div>
              <div className="-properties">
                <div>
                  <div className='label-default-basic'>Correo</div>
                  <div className='label-medium-semibold -email'>{player.email || '-'}</div>
                </div>
                <div>
                  <div className='label-default-basic'>Teléfono</div>
                  <div className='label-medium-semibold'>{player.phone || '-'}</div>
                </div>
              </div>
            </Panel>
            <div>&nbsp;</div>
            <Panel>
              <PanelTitle>Control Parental</PanelTitle>
              <div className="-file-container">
              {player.parental_control_file_id &&
                <File
                  file={{
                    name: player.parental_control_file_name,
                    source: process.env.REACT_APP_IMAGE_BASE_URL + '/files/' + player.parental_control_file_id + '?download'
                  }}
                />
              }
              </div>
              {!player.parental_control_file_id &&
                <div label="label-default-semibold">No hay documentos guardados.</div>
              }
            </Panel>
            <div>&nbsp;</div>
            <Panel>
              <PanelTitle>Archivos del jugador</PanelTitle>
              <div className="-file-container">
                {player?.archive?.length > 0 && player.archive.map(file => 
                  <File
                    file={{ ...file, source: process.env.REACT_APP_IMAGE_BASE_URL + '/files/' + file.id + '?download' }}
                  />
                )}
              </div>
              {player?.archive?.length === 0 &&
                <div label="label-default-semibold">No hay archivos guardados.</div>
              }
            </Panel>
            <Route exact path="/soccer/competition/:competitionId/team/:teamId/player/:playerId/edit">
              <OldPlayerFormModal onCloseRequested={handleClose} />
            </Route>
          </>
        }
        {playerState === LOADING && <LoadingPanel/>}
      </div>
    </div>
  )
}

const renderGender = (gender) => {
  if (gender === 'MALE') return "Hombre"
  if (gender === 'FEMALE') return "Mujer"
  return "No especificado"
}

export default PlayerView
